import {PDF_MARGIN_MM, PDF_PAGE_HEIGHT_MM, PDF_PAGE_WIDTH_MM} from '../../services/pdf-pagination';

// A4 portrait at 96dpi, used only for the on-screen editor page guide and the print-preview layout.
// The margin is derived from PDF_MARGIN_MM (services/pdf-pagination.ts) so the guide always matches what
// actually gets printed instead of drifting out of sync with it.
const PX_PER_MM = 96 / 25.4;
export const PAGE_WIDTH_PX = Math.round(PDF_PAGE_WIDTH_MM * PX_PER_MM);
export const PAGE_HEIGHT_PX = Math.round(PDF_PAGE_HEIGHT_MM * PX_PER_MM);
export const PAGE_MARGIN_PX = Math.round(PDF_MARGIN_MM * PX_PER_MM);
export const CONTENT_WIDTH_PX = PAGE_WIDTH_PX - 2 * PAGE_MARGIN_PX;
export const CONTENT_HEIGHT_PX = PAGE_HEIGHT_PX - 2 * PAGE_MARGIN_PX;
// Patient header printed above the form on page 1 (varies with address length); used only for the editor guide.
export const FIRST_PAGE_HEADER_PX = 150;
